<!-- Titre -->
<div class="page-title">
	{{ initialSite.sit_libelle }}
</div>

<div class="flex flex-column h-full justify-content-between">
	<gz-tabMenu class="flex-shrink-0" [model]="tabs"></gz-tabMenu>
	<ui-view name="siteTabContent" class="mt-2 h-full flex flex-column"></ui-view>
</div>